import { Alert, Box, Button, Container, FormField, Input, RadioGroup, SegmentedControl } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../../commons/functions';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../../layout';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiHydraulicOilLevel, mdiTankerTruck } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import DPModal from '../../../../../../components/DPModal';
import Favorites from '../../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { ItemFuelMesure } from '../../../../../../resources/types';
const _preserve = React.version;

export const OPSFuelTanksAddMeasurePage = () => {
    const { menu } = useGlobalState();



    const [tank, setTank] = useState<ItemFuelMesure>({ idMovementTank: 0, jsonMeasure: {}, obs: "", load: 0 });




    useEffect(() => {
        //handleCheckFuel();
        if (tank && tank.tank === "MEASURE")
            setTank({ ...tank, load: 0 });
    }, [tank]);
    const handleAddMeasure = async () => {

        try {
            setLoading(true)

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/tanks/addmeasure',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(tank),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setTank({ idMovementTank: 0, jsonMeasure: {} });
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }
    const isDisabledRegister = () => {
        let disabled = false;
        if (!tank) return true;
        if (!tank.dateMeasure || !tank.tank || !tank.liters || tank.liters === 0 || !tank.receipt || tank.receipt === 0 || !tank.measureType)
            return true;
        if (tank.measureType === "LOAD" && (!tank.load || tank.load === 0))
            return true;
        if (tank.measureType === "LOAD" && tank.liters < tank.load)
            return true;
        return disabled
    }
    //
    return (
        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />} description={"Ingreso de nueva medición física de estanque o carga COPEC"}>
                            Ingreso de medición
                        </Header>
                        <div style={{ maxWidth: 600 }}>
                            <Container footer={
                                <Box float="right">
                                    <Button variant="primary"
                                        disabled={isDisabledRegister()}
                                        onClick={() => {
                                            handleAddMeasure()
                                        }}>Registrar</Button>

                                </Box>
                            }>
                                <SpaceBetween direction='vertical' size='xs'>
                                    <SpaceBetween direction='horizontal' size='xs'>

                                        <FormField label={"Tipo de combustible"}>
                                            <SegmentedControl
                                                selectedId={tank.tank}
                                                onChange={({ detail }) => {
                                                    setTank({ ...tank, tank: detail.selectedId })
                                                }}
                                                options={[
                                                    { text: "AVGAS", id: "AVGAS" },
                                                    { text: "JP1", id: "JP1" },
                                                ]}
                                            />
                                        </FormField>
                                    </SpaceBetween>

                                    {tank?.tank && tank?.tank !== "" && (
                                        <SpaceBetween direction='vertical' size='xs'>
                                            <FormField label={"Tipo de medición"}>
                                                <RadioGroup value={tank.measureType}
                                                    direction='horizontal'
                                                    onChange={({ detail }) => {
                                                        setTank({ ...tank, measureType: detail.value })
                                                    }}
                                                    items={[
                                                        {
                                                            value: "MEASURE",
                                                            description: <Icon path={mdiHydraulicOilLevel} size={1} />,
                                                            label: "Medición físico"
                                                        },
                                                        {
                                                            value: "LOAD",
                                                            description: <Icon path={mdiTankerTruck} size={1} />,
                                                            label: "Carga COPEC"
                                                        },
                                                    ]}
                                                />
                                            </FormField>
                                        </SpaceBetween>
                                    )}


                                    {tank?.tank && tank?.tank !== "" && tank.measureType && tank.measureType !== "" && (
                                        <SpaceBetween direction='vertical' size='xs'>
                                            {tank.measureType === "LOAD" && (
                                                <Alert type="warning">
                                                    Cargas copec, medición en litros debe indicar el saldo total en litros despues de efectuada la carga
                                                </Alert>
                                            )}
                                            <SpaceBetween direction='horizontal' size='xs'>
                                                <FormField label={"Fecha de medición"}>
                                                    <DPModal date={tank.dateMeasure ?? ""} width={130}
                                                        today
                                                        end={new Date()}
                                                        onConfirm={(date) => {
                                                            setTank({ ...tank, dateMeasure: date });
                                                        }} />
                                                </FormField>
                                                <div style={{ maxWidth: 140 }}>
                                                    <FormField label={"Litros"}
                                                        constraintText={`Medición física${tank.measureType === "LOAD" ? " después de la carga" : ""}`}>
                                                        <Input
                                                            type='number'
                                                            value={tank?.liters?.toString() ?? "0"}
                                                            onChange={(e) => setTank({ ...tank, liters: Number(e.detail.value) })}
                                                        ></Input>
                                                    </FormField>
                                                </div>
                                                {tank.measureType === "LOAD" && (
                                                    <div style={{ maxWidth: 140 }}>
                                                        <FormField label={"Carga"}
                                                            constraintText="Cantidad de litros cargados en la operación"
                                                        >
                                                            <Input
                                                                type='number'
                                                                value={tank?.load?.toString() ?? "0"}
                                                                onChange={(e) => setTank({ ...tank, load: Number(e.detail.value) })}
                                                            ></Input>
                                                        </FormField>
                                                    </div>
                                                )}
                                                <div style={{ maxWidth: 140 }}>
                                                    <FormField label={"Folio actual"} constraintText="Último folio no utilizado">
                                                        <Input
                                                            type='number'
                                                            value={tank?.receipt?.toString() ?? "0"}
                                                            onChange={(e) => setTank({ ...tank, receipt: Number(e.detail.value) })}
                                                        ></Input>
                                                    </FormField>
                                                </div>
                                            </SpaceBetween>



                                            <div style={{ maxWidth: 140 * 3 }}>
                                                <FormField label={"Observaciones"} constraintText="Información opcional que se desee registrar">
                                                    <Input value={tank.obs}
                                                        onChange={({ detail }) => {
                                                            setTank({ ...tank, obs: detail.value })
                                                        }} />
                                                </FormField>
                                            </div>

                                        </SpaceBetween>

                                    )}



                                </SpaceBetween>
                            </Container>
                        </div>
                    </SpaceBetween>


                </>
            } />
    );
};
